<template>
  <div class="flex h-full min-h-0 flex-col overflow-hidden rounded-md border bg-background">
    <div v-if="loading" class="p-3 text-xs text-muted-foreground">Chargement de l'aperçu…</div>
    <div v-else-if="error" class="p-3 text-xs text-destructive">{{ error }}</div>
    <div v-else class="flex min-h-0 flex-1 flex-col">
      <div v-if="sheetNames.length > 1" class="flex shrink-0 flex-wrap gap-1 border-b bg-muted/40 px-2 py-1.5">
        <button v-for="(name, i) in sheetNames" :key="name" type="button"
                class="rounded px-2 py-0.5 text-xs"
                :class="i === activeSheet ? 'bg-primary text-primary-foreground' : 'text-muted-foreground hover:bg-accent'"
                @click="selectSheet(i)">{{ name }}</button>
      </div>
      <div class="min-h-0 flex-1 overflow-auto">
        <table v-if="rows.length" class="border-collapse text-xs">
          <tbody>
            <tr v-for="(row, r) in rows" :key="r" :class="r === 0 ? 'bg-muted font-medium' : ''">
              <td v-for="(cell, c) in row" :key="c" class="whitespace-nowrap border border-border px-2 py-1">{{ cell }}</td>
            </tr>
          </tbody>
        </table>
        <p v-else class="p-3 text-xs text-muted-foreground">Feuille vide.</p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "ExcelPreview",
  props: {
    url: { type: String, required: true },
  },
  data() {
    return { loading: true, error: "", sheetNames: [], activeSheet: 0, rows: [] };
  },
  async mounted() {
    await this.load();
  },
  methods: {
    async load() {
      this.loading = true;
      this.error = "";
      try {
        const XLSX = await import("xlsx");
        const token = await this.$auth.getAccessTokenSilently();
        const res = await axios.get(this.url, {
          responseType: "arraybuffer",
          headers: { Authorization: `Bearer ${token}` },
        });
        this.xlsx = XLSX;
        this.workbook = XLSX.read(new Uint8Array(res.data), { type: "array" });
        this.sheetNames = this.workbook.SheetNames || [];
        this.selectSheet(0);
      } catch (e) {
        console.log(e);
        this.error = "Aperçu indisponible pour ce fichier.";
      } finally {
        this.loading = false;
      }
    },
    selectSheet(index) {
      this.activeSheet = index;
      const sheet = this.workbook.Sheets[this.sheetNames[index]];
      const rows = sheet
        ? this.xlsx.utils.sheet_to_json(sheet, { header: 1, defval: "", blankrows: false })
        : [];
      this.rows = this.dropEmptyColumns(rows);
    },
    dropEmptyColumns(rows) {
      if (!rows.length) return rows;
      const colCount = Math.max(...rows.map((r) => r.length));
      const keep = [];
      for (let c = 0; c < colCount; c++) {
        const hasValue = rows.some((r) => {
          const v = r[c];
          return v !== undefined && v !== null && String(v).trim() !== "";
        });
        if (hasValue) keep.push(c);
      }
      return rows.map((r) => keep.map((c) => (r[c] === undefined ? "" : r[c])));
    },
  },
};
</script>
